import { invalid, max, regex, required } from "common/forms"
import * as yup from "yup"

export const MAX_CONTENT = 500

const schema = yup
  .object({
    fullName: yup
      .string()
      .required(required.default)
      .max(...max.fullname)
      .matches(regex.fullname, invalid.fullname),
    phone: yup
      .string()
      .required(required.phoneNumber)
      .matches(regex.phoneNumber, invalid.phoneNumber),

    emailAddress: yup.string().required(required.default).email(invalid.email),
    licenceNumber: yup
      .string()
      .required(required.licenseNumber)
      .matches(regex.licenseNumber, invalid.licenseNumber),
    content: yup
      .string()
      .required(required.default)
      .max(MAX_CONTENT, `ניתן להזין עד ${MAX_CONTENT} תווים`),
  })
  .defined()

export const initialFormState: yup.InferType<typeof schema> = {
  fullName: "",
  phone: "",
  emailAddress: "",
  licenceNumber: "",
  content: "",
}

export default schema
